// extracted by mini-css-extract-plugin
export default {"container":"DateTime_container__-bw0B","darkmode":"DateTime_darkmode__4X00s"};